import { formValues } from 'redux-form';

import { Snapcode } from './Snapcode';

export const SnapcodeContainer = formValues<any, any>((props: any) => ({
  isDefault: `${props.name}.default`,
  id: `${props.name}.id`,
}))(Snapcode);
